import BaseChartCard from 'common/components/BaseChartCard'
import { useGetWaterMineralLineChart } from 'modules/water/api/queries'
import { WaterMineralChart } from 'modules/water/api/types'
import { MineralType } from 'modules/water/constants'
import { getMinMaxValueFromSeries, getSeries } from 'modules/water/utils/chart'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Stack from '@mui/material/Stack'

import { CategoryButtonGroup } from '../CategoryButtonGroup'
import LineChart from '../LineChart'

const range = {
  [MineralType.Calcium]: [0, 400],
  [MineralType.Magnesium]: [0, 1400],
  [MineralType.Potassium]: [0, 400],
}

const MineralChart = () => {
  const { t } = useTranslation('water')
  const { data, isFetching, refetch } = useGetWaterMineralLineChart()
  const [filter, setFilter] = useState<MineralType>(MineralType.Calcium)
  const [open, setOpen] = useState(false)
  const [min, setMin] = useState(0)
  const [max, setMax] = useState(0)

  const series = getSeries<WaterMineralChart>(MineralType, data)

  useEffect(() => {
    if (series) {
      let minTemp = range[filter][0]
      let maxTemp = range[filter][1]
      const { min: mn, max: mx } = getMinMaxValueFromSeries(series[filter])

      if (mn < minTemp) {
        minTemp = mn
      }

      if (mx > maxTemp) {
        maxTemp = mx
      }

      setMin(minTemp)
      setMax(maxTemp)
    }
  }, [series])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const chartData = [
    {
      id: MineralType.Calcium,
      name: t(MineralType.Calcium),
      data: series[MineralType.Calcium],
    },
    {
      id: MineralType.Magnesium,
      name: t(MineralType.Magnesium),
      data: series[MineralType.Magnesium],
    },
    {
      id: MineralType.Potassium,
      name: t(MineralType.Potassium),
      data: series[MineralType.Potassium],
    },
  ]

  const filteredChartData = chartData.filter((item) => item.id === filter)

  return (
    <BaseChartCard title={t('mineral.report')} refresh={refetch}>
      <Stack direction="row" spacing={1} sx={{ overflowX: 'scroll', py: 2, pl: 2 }}>
        <CategoryButtonGroup<MineralType>
          options={chartData.map((item) => ({ label: item.name, value: item.id }))}
          selected={filter}
          onChange={(value: MineralType) => setFilter(value)}
          size="small"
        />
      </Stack>
      <LineChart
        yTitle={`${t('value')} (ppm)`}
        min={min}
        max={max}
        yData={filteredChartData}
        isLoading={isFetching}
        dataLength={data?.length || 0}
      />
    </BaseChartCard>
  )
}

export default MineralChart
